module.exports = __webpack_public_path__ + "img/list30.aedb6472.jpeg";